import { Component, OnInit, ViewChild } from '@angular/core';
import { CSVDataService } from '@app/export/CSVDataService';
import { AdminService } from '@app/services/admin/admin.service';
import { ConfirmationService, MessageService } from 'primeng/api';

@Component({
  selector: 'app-admin-sign-type',
  templateUrl: './admin-sign-type.component.html',
  styleUrls: ['./admin-sign-type.component.css']
})
export class AdminSignTypeComponent implements OnInit {
  @ViewChild('dt') table;
  @ViewChild('globalfilter') globalfilter;
  signtypes: any[] = [];
  cols: any[];
  formdata;
  display = false;
  displayaddsigntype = false;
  value: any;

  constructor(
    private adminService: AdminService,
    private messageService: MessageService,
    public confirmationService: ConfirmationService) { }

  ngOnInit() {
    this.cols = [
      { field: 'name', header: 'Typnamn' },
      { field: 'sort', header: 'Sortering' }
    ];
    this.getSignTypes();
  }

  edit(formdata) {
    this.formdata = formdata;
    this.display = true;
  }

  getSignTypes() {
    this.adminService.GetSignTypes().subscribe(data => {
      if (data) {
        this.signtypes = data;
      }
    });
  }

  saveSignType(evt) {
    this.adminService.UpdateSignType(evt).subscribe(x => {
      this.display = false;
      this.messageService.add({ severity: 'success', summary: 'Information', detail: 'Utmärkelsetyp uppdaterad.' });
      this.getSignTypes();
    });
  }

  saveAddSignType(evt) {
    this.adminService.AddSignType(evt).subscribe(resp => {
      if (resp) {
        this.messageService.add({ severity: 'success', summary: 'Information', detail: 'Utmärkelsetyp tillagd.' });
        this.getSignTypes();
        this.displayaddsigntype = false;
      }
    });
  }

  cancelEdit() {
    this.display = false;
  }

  cancelAdd() {
    this.displayaddsigntype = false;
  }
  addCommittee() {
    this.displayaddsigntype = true;
  }

  remove(data) {
    this.adminService.RemoveSignType(data).subscribe(resp => {
      if (resp) {
        this.messageService.add({ severity: 'success', summary: 'Information', detail: 'Sign_Type har raderats.' });
        this.getSignTypes();
      }
    });
  }

  exportToCSV() {
    const firstrow = 'Id;Namn;Sorteringsordning';
    const filnamn = 'OF_signtypes';
    CSVDataService.exportToCsv(filnamn + '.csv', this.signtypes, firstrow);
  }

  resetFilter() {
    this.table.reset();
    this.table.clearState();
    this.value = null;
    this.globalfilter.nativeElement.value = null;
  }

  removeConfirmDialog(data): void {
     this.confirmationService.confirm({
      header: 'Bekräftelse',
      message: 'Är du säker på att du vill ta bort aktuell sign_type?',
      acceptLabel: 'Ja',
      rejectLabel: 'Nej',
      accept: () => {
         this.remove(data);
      },
      reject: () => {
      }
    });
  }
}
